import classNames from 'classnames';
import { FC } from 'react';

import type { Article } from '@/entities/article';

import styles from './articleFullList.module.scss';
import ArticleCategoryList from '../ArticleCategoryList/ArticleCategoryList';


interface ArticleFullListProps {
  value?: Article[];
  className?: string;
}

const ArticleFullList: FC<ArticleFullListProps> = (props) => {
  const { value, className } = props;

  const subcategoryDisplayCountById: Record<number, number> = {};

  if (value?.length) {
    let startCount = Infinity;
    for (const article of value) {
      for (const subcategory of article.subcategories) {
        startCount = Math.min(startCount, subcategory?.sort_order ?? 0);
      }
    }

    if (startCount === Infinity) startCount = 0;

    let counter = 0;
    for (const article of value) {
      for (const subcategory of article.subcategories) {
        subcategoryDisplayCountById[subcategory.id] = startCount + counter;
        counter += 1;
      }
    }
  }

  function renderArticles(article: Article, index: number) {
    return (
      <ArticleCategoryList
        key={`article-${article.id}-${index}`}
        className={styles.container__list}
        subcategoryDisplayCountById={subcategoryDisplayCountById}
        value={article}
      />
    );
  }

  return (
    <section className={classNames(className, styles.container)}>
      {value?.map(renderArticles)}
    </section>
  );
};

export default ArticleFullList;
